import { render } from "./Kontakt.vue?vue&type=template&id=332fa9ec"
import script from "./Kontakt.vue?vue&type=script&lang=ts"
export * from "./Kontakt.vue?vue&type=script&lang=ts"

import "./Kontakt.vue?vue&type=style&index=0&id=332fa9ec&lang=scss"
script.render = render

export default script